import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: ${spacing(3)};
  padding: ${spacing(12)} ${spacing(6)};
`

export const title = css`
  font-family: ${font_family_weight_medium};
  ${font_lg}
  color: ${text_colorTextPrimary};
`

export const detail = css`
  font-family: ${font_family_weight_regular};
  ${font_md}
  color: ${text_colorTextSecondary};
  max-width: 360px;
`
